import {useQuery, UseQueryResult} from "react-query";
import {API, ApiResponseBase, CustomAxiosError} from "../../../../logics/api-config";
import {IMonthlyInvoice} from "../../../../utils/interfaces/MonthlyInvoice/IMonthlyInvoice";


async function doGet(month: number | undefined, year: number | undefined, restaurateur_id: number | undefined): Promise<IMonthlyInvoice[]> {
    try {
        const response = await API.get(`/accounting/monthly_invoices/month/${month}/year/${year}/restaurateur/${restaurateur_id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
}


const useApiGetMonthlyInvoicesDetails = (
    month: number | undefined,
    year: number | undefined,
    restaurateur_id: number | undefined
): UseQueryResult<IMonthlyInvoice[], CustomAxiosError> => {
    return useQuery<IMonthlyInvoice[], CustomAxiosError>("getMonthlyInvoicesDetails", () => doGet(month, year, restaurateur_id));
};

export default useApiGetMonthlyInvoicesDetails;
